{
    "ChanneltypesLabel": "Channel Type(s):",
    "ChanneltypesOptionAny": "[Any Channel]",
    "ChanneltypesOptionVoice": "Voice Calls",
    "CalltypedirectionLabel": "Call Type / Direction:",
    "CalltypedirectionOptionAny": "[Any Call Type]",
    "CalltypedirectionOptionUnknownorinitiating": "[Unknown Or Initiating]",
    "CalltypedirectionOptionInbound": "Inbound Only",
    "CalltypedirectionOptionOutbound": "Outbound Only",
    "CalltypedirectionOptionExternalAll": "External Only",
    "CalltypedirectionOptionExternalInbound": "External (Inbound Only)",
    "CalltypedirectionOptionExternalOutbound": "External (Outbound Only)",
    "CalltypedirectionOptionExternalTrktotrk": "External Trunk-To-Trunk",
    "CalltypedirectionOptionInternalAll": "Internal Only",
    "CalltypedirectionOptionInternalInbound": "Internal (Inbound Only)",
    "CalltypedirectionOptionInternalOutbound": "Internal (Outbound Only)",
    "AnswertypeLabel": "Answer Type:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Without CLI/CallerID",
    "ClicalleridreceivedReceived": "With CLI/CallerID",
    "AnswertypeOptionAny": "[Any Answer Type]",
    "AnswertypeOptionNotans": "Not Answered",
    "AnswertypeOptionAns": "Answered",
    "AnswertypeOptionAbandoned": "Abandoned",
    "AnswertypeOptionAdvancedFrom": "Advanced From",
    "AnswertypeOptionAdvancedTo": "Advanced To",
    "AnswertypeOptionOverflowedFrom": "Overflowed Off",
    "AnswertypeOptionOverflowedTo": "Overflowed In",
    "ClicalleridreceivedLabel": "CLI / CallerID Received:",
    "DiddigitsLabel": "DDI Digits:",
    "AccountcodesLabel": "Account Code(s):",
    "CallidentifierLabel": "Call Identifier (Telephony Platform):",
    "SubjectfilterLabel": "Subject Filter:",
    "TreatconfcallasExternalLabel": "Treat Conference Call As External:",
    "NAME": "MiscellaneousFiltering",
    "MiscellaneousFiltering_SectionHeader": "Miscellaneous Filtering",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]"
}